const fullDate = (foedselsnummer: string): string => {
    // Sjekke om foedselsnummer er ugyldig
    if (!foedselsnummer || foedselsnummer.length !== 6 || Number.isNaN(Number(foedselsnummer))) return '';

    // Splitte foedselsnummer i intervaller på to, for dag, maaned og aar
    const now = new Date();
    const day = foedselsnummer.substring(0, 2);
    const month = foedselsnummer.substring(2, 4);
    const year = foedselsnummer.substring(4, 6);

    // Sjekk om siste to sifrene til kunde er < eller > enn 19. Autofyller aarstall til 19xx om xx er høyere eller lik 19
    let fullYear;
    if (Number(year) >= now.getFullYear() - 2000) {
        fullYear = `19${year}`;
    } else {
        fullYear = `20${year}`;
    }

    // Lage et dato-testobjekt for å sjekke gyldigheten til inputen
    const testDate = new Date(`${fullYear}-${month}-${day}`);

    if (Number.isNaN(testDate.getTime())) return '';

    // Returnere fodelsdato på format DDMMYYYY
    return `${day}${month}${fullYear}`;
};

export const formatNafMemberFullDate = (birthDate: string) => {
    const date = new Date(birthDate);

    const month = date.getMonth() + 1;

    const finalMonth = month < 10 ? `0${month}` : month;

    return `${date.getDate()}${finalMonth}${date.getFullYear()}`;
};

export default fullDate;
